(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dmr-compare"]) return;
  try {
    
  function dmrCompareInit(scope){scope.querySelectorAll('[data-dmr-compare]:not([data-dmr-ready])').forEach(root=>{root.dataset.dmrReady='true';const controls=root.querySelector('.dmr-compare-controls');if(!controls)return;const inputs=[...controls.querySelectorAll('input')];controls.hidden=inputs.length<3;inputs.forEach(input=>input.addEventListener('change',()=>{if(!input.checked&&inputs.filter(el=>el.checked).length<2){input.checked=true;return;}root.querySelectorAll('[data-dmr-column]').forEach(cell=>{cell.hidden=!inputs.find(el=>el.value===cell.dataset.dmrColumn)?.checked;});}));});}
  dmrCompareInit(document);document.addEventListener('shopify:section:load',event=>dmrCompareInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmr-cookie-notice"]) return;
  try {
    
function dmrConsentInit(){
  const banner=document.querySelector('[data-dmr-cookie]');
  if(!banner||banner.dataset.ready||!window.Shopify?.loadFeatures)return;
  banner.dataset.ready='true';
  Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{
    if(error||!Shopify.customerPrivacy)return;
    const api=Shopify.customerPrivacy,buttons=[...banner.querySelectorAll('[data-dmr-consent]')];let opener=null;
    document.querySelectorAll('[data-dmr-cookie-open]').forEach(button=>{button.hidden=false;button.addEventListener('click',()=>{opener=button;banner.hidden=false;buttons[0].focus();});});
    const previous=api.currentVisitorConsent();banner.hidden=!api.shouldShowBanner()||['analytics','marketing','preferences'].every(key=>previous[key]==='yes'||previous[key]==='no');
    buttons.forEach(button=>button.addEventListener('click',()=>{
      buttons.forEach(b=>b.disabled=true);banner.querySelector('[data-dmr-consent-error]').hidden=true;
      const consent=button.dataset.dmrConsent==='yes';
      api.setTrackingConsent({analytics:consent,marketing:consent,preferences:consent},result=>{
        buttons.forEach(b=>b.disabled=false);
        if(result?.error){banner.querySelector('[data-dmr-consent-error]').hidden=false;return;}
        banner.hidden=true;if(opener)opener.focus();
      });
    }));
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',dmrConsentInit);else dmrConsentInit();
document.addEventListener('shopify:section:load',dmrConsentInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmr-header"] && !Shopify.designMode) return;
  try {
    
  function dmrHeaderInit(root) {
    root.querySelectorAll('[data-dmr-header]:not([data-dmr-enhanced])').forEach(header => {
      header.setAttribute('data-dmr-enhanced', '');
      const button = header.querySelector('[data-dmr-menu]');
      const nav = header.querySelector('.main-nav');
      if (!button || !nav) return;
      const closeDropdowns = except => {
        nav.querySelectorAll('details[open]').forEach(detail => {
          if (detail !== except) detail.open = false;
        });
      };
      button.addEventListener('click', () => {
        const open = nav.classList.toggle('open');
        button.setAttribute('aria-expanded', String(open));
        if (!open) closeDropdowns();
      });
      nav.addEventListener('click', event => {
        const summary = event.target.closest('summary');
        if (summary) closeDropdowns(summary.parentElement);
      });
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const opened = nav.querySelector('details[open]');
        if (opened) {
          closeDropdowns();
          opened.querySelector('summary').focus();
        } else if (nav.classList.contains('open')) {
          nav.classList.remove('open');
          button.setAttribute('aria-expanded', 'false');
          button.focus();
        } else return;
        event.preventDefault();
      });
      header.addEventListener('focusout', event => {
        if (event.relatedTarget && !header.contains(event.relatedTarget)) closeDropdowns();
      });
    });
  }
  dmrHeaderInit(document);
  document.addEventListener('shopify:section:load', event => dmrHeaderInit(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-dmr-header]').forEach(header => {
      if (header.contains(event.target)) return;
      header.querySelectorAll('details[open]').forEach(detail => detail.open = false);
      header.querySelector('.main-nav')?.classList.remove('open');
      header.querySelector('[data-dmr-menu]')?.setAttribute('aria-expanded', 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmr-home"] && !Shopify.designMode) return;
  try {
    
  function dmrHomeInit(scope) {
    scope.querySelectorAll('[data-dmr-home]:not([data-dmr-ready])').forEach(root => {
      root.dataset.dmrReady = 'true';
      const grid = root.querySelector('[data-dmr-pc-grid]');
      const cards = [...grid.querySelectorAll('[data-dmr-pc-price]')];
      const buttons = [...root.querySelectorAll('[data-dmr-budget]')];
      const sort = root.querySelector('[data-dmr-pc-sort]');
      const clear = root.querySelector('[data-dmr-clear-budget]');
      const countLabel = root.querySelector('[data-dmr-pc-count]');
      const empty = root.querySelector('[data-dmr-no-pcs]');
      let active = buttons.find(button => button.dataset.dmrBudget === 'all');
      root.querySelector('[data-dmr-budget-controls]').hidden = cards.length < 2;
      function update() {
        const lower = active.dataset.min === undefined ? -Infinity : Number(active.dataset.min);
        const upper = active.dataset.max === undefined ? Infinity : Number(active.dataset.max);
        let count = 0;
        cards.forEach(card => {
          const price = Number(card.dataset.dmrPcPrice);
          card.hidden = !(price >= lower && price < upper);
          if (!card.hidden) count++;
        });
        buttons.forEach(button => {
          button.classList.toggle('active', button === active);
          button.setAttribute('aria-pressed', String(button === active));
        });
        const ordered = [...cards];
        if (sort.value !== 'collection') {
          const direction = sort.value === 'price-descending' ? -1 : 1;
          ordered.sort((a, b) => direction * (Number(a.dataset.dmrPcPrice) - Number(b.dataset.dmrPcPrice)));
        }
        ordered.forEach(card => grid.appendChild(card));
        countLabel.textContent = countLabel.dataset.countLabel.replace('[count]', String(count));
        empty.hidden = count > 0;
        clear.hidden = active.dataset.dmrBudget === 'all';
      }
      buttons.forEach(button => button.addEventListener('click', () => { active = button; update(); }));
      sort.addEventListener('change', update);
      clear.addEventListener('click', () => {
        active = buttons.find(button => button.dataset.dmrBudget === 'all');
        update();
        active.focus();
      });
    });
  }
  dmrHomeInit(document);
  document.addEventListener('shopify:section:load', event => dmrHomeInit(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dmr-product"]) return;
  try {
    
  function dmrProductInit(scope) {
    scope.querySelectorAll('[data-dmr-product]:not([data-dmr-ready])').forEach(root => {
      root.dataset.dmrReady = 'true';
      const image = root.querySelector('.dmr-main-image');
      const zoom = root.querySelector('[data-dmr-zoom-link]');
      const photos = [...root.querySelectorAll('[data-dmr-photo]')];
      function showPhoto(src, alt) {
        if (!image || !src) return;
        image.src = src; image.removeAttribute('srcset'); if (alt) image.alt = alt;
        if (zoom) zoom.href = src;
        photos.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dmrPhoto === src)));
      }
      photos.forEach(button => button.addEventListener('click', () => showPhoto(button.dataset.dmrPhoto, button.dataset.dmrAlt)));
      const variants = root.querySelector('[data-dmr-variant]');
      variants?.addEventListener('change', () => {
        const option = variants.selectedOptions[0]; const available = option.dataset.available === 'true';
        root.querySelectorAll('[data-dmr-price]').forEach(el => el.textContent = option.dataset.money);
        root.querySelectorAll('[data-dmr-was]').forEach(el => {el.hidden = !option.dataset.was; el.textContent = option.dataset.was;});
        root.querySelectorAll('[data-dmr-saving]').forEach(el => {el.hidden = !option.dataset.saving; el.textContent = option.dataset.saving;});
        root.querySelectorAll('[data-dmr-stock]').forEach(el => el.textContent = option.dataset.stock);
        root.querySelectorAll('[data-dmr-stock-note]').forEach(el => el.hidden = option.dataset.leadTime !== 'true');
        root.querySelectorAll('[data-dmr-product-question]').forEach(el => el.href = option.dataset.question);
        root.querySelectorAll('[data-dmr-add]').forEach(el => el.disabled = !available);
        root.querySelectorAll('[data-dmr-add-text]').forEach(el => el.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel);
        showPhoto(option.dataset.photo);
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
        root.dispatchEvent(new CustomEvent('dmr:variant-change', {bubbles: true, detail: {id: option.value, price: Number(option.dataset.price)}}));
      });
      const information = root.querySelector('.dmr-product-information');
      const cleanupInformation = [];
      function openInformation(hash, focus = true) {
        const panel = [...information.querySelectorAll('details[id]')].find(detail => '#' + detail.id === hash);
        if (!panel || panel.hidden) return false;
        panel.open = true;
        const summary = panel.querySelector('summary');
        if (focus) summary?.focus({preventScroll: true});
        panel.scrollIntoView({block: 'start', behavior: 'instant'});
        return true;
      }
      root.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const hash = link.getAttribute('href');
        if (!openInformation(hash)) return;
        event.preventDefault();
        if (location.hash !== hash) history.pushState({}, '', hash);
      });
      const handleHash = () => {
        if (!root.isConnected) return;
        if (location.hash) openInformation(location.hash);
      };
      window.addEventListener('hashchange', handleHash);
      cleanupInformation.push(() => window.removeEventListener('hashchange', handleHash));
      handleHash();
      const mobilePurchase = root.querySelector('[data-dmr-mobile-purchase]');
      const mainPurchase = root.querySelector('.dmr-product-form [data-dmr-add]');
      if (mobilePurchase && mainPurchase && 'IntersectionObserver' in window) {
        let purchaseAboveViewport = false;
        const updateMobilePurchase = () => {
          const keyboardActive = document.activeElement?.matches('input, select, textarea, [contenteditable="true"]');
          mobilePurchase.hidden = !purchaseAboveViewport || keyboardActive;
        };
        mobilePurchase.hidden = true;
        const observer = new IntersectionObserver(entries => {
          purchaseAboveViewport = entries[0].boundingClientRect.bottom <= 0;
          updateMobilePurchase();
        });
        observer.observe(mainPurchase);
        const handleFocusOut = () => requestAnimationFrame(updateMobilePurchase);
        document.addEventListener('focusin', updateMobilePurchase);
        document.addEventListener('focusout', handleFocusOut);
        cleanupInformation.push(() => {
          observer.disconnect();
          document.removeEventListener('focusin', updateMobilePurchase);
          document.removeEventListener('focusout', handleFocusOut);
        });
      }
      const handleUnload = event => {
        if (!event.target.contains(root)) return;
        cleanupInformation.forEach(cleanup => cleanup());
        document.removeEventListener('shopify:section:unload', handleUnload);
      };
      document.addEventListener('shopify:section:unload', handleUnload);

    });
  }
  dmrProductInit(document);document.addEventListener('shopify:section:load',event=>dmrProductInit(event.target));

  } catch(e) { console.error(e); }
})();
})();
